<template>
	<b-navbar toggleable="sm" type="dark" variant="black-light" class="p-0 m-0 w-100 d-flex justify-content-between" >
		<!-- Logo Dcx -->
		<b-navbar-brand class="mx-4">
			<!-- Icone Dcx -->
			<b-img :src="AbsoluteLink('Images/Logo_DCX_Blanc.png')" class="d-inline-block" />
		</b-navbar-brand>
		<!-- TITRE SUPERVISION-->
      	<b-navbar-brand>SUPERVISION</b-navbar-brand>
		<!-- Boutons/menus d'actions globales sur grand écran ou petit écran en paysage -->

		<b-navbar-nav class="flex-grow-0 px-3">
            <!-- Bouton de Téléchargement -->
            <b-nav-item v-if="downloadList && downloadList.length > 0" :link-classes="['px-1', { 'py-1': checkSmLandscape() }]">
                <b-dropdown v-b-tooltip.hover :title="$t('Downloads')" ref="dlDrop" show="true" variant="dark" size="sm" :toggle-class="['btn-circle text-decoration-none d-flex align-items-center justify-content-center']" right no-caret>
                    <template #button-content>
                        <b-iconstack font-scale="1">
                            <!-- Animation de fin -->
                            <b-icon v-if="animation" animation="throb" stacked scale="1.8" icon="download" class="text-success" />
                            <!-- Flèche verte pendant le spinner -->
                            <b-icon v-else-if="downloadList.filter(u => u.State === downloadStateEnum.InProgress).length > 0 && !animation" stacked icon="download" class="text-secondary" />
                            <!-- Flèche normale -->
                            <b-icon v-else stacked icon="download" />
                            <!-- Spinner -->
                            <b-icon v-if="downloadList.filter(u => u.State === downloadStateEnum.InProgress).length > 0 && !animation" stacked icon="arrow-clockwise" scale="1.6" animation="spin" class="text-secondary" />
                        </b-iconstack>
                    </template>
                    <!-- Liste des téléchargements -->
                    <b-dropdown-item v-for="download in downloadList.filter(u => u.State != downloadStateEnum.InProgress).sort((a, b) => b.Index - a.Index)" :key="download.Index" @click="generateDownload(download)" class="p-1 border" :class="download.State === downloadStateEnum.Downloaded ? '' : 'bg-gray'">
                        <font-awesome-icon v-if="download.State != downloadStateEnum.Error" :icon="['fas', getExtensionIcon(download.Type)]" class="text-left" />
                        <b-icon v-if="download.State === downloadStateEnum.Error" icon="x-circle" scale="0.9" variant="danger" />
                        {{ download.Name }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-nav-item>
			<b-nav-item link-classes="px-1">
				<!-- BOUTON DE DECONNEXION-->
				<b-button v-b-tooltip.hover title="Déconnexion" @click="logOut()" variant="dark" size="sm" class="btn-circle d-flex align-items-center justify-content-center">
					<b-icon icon="door-open" />
				</b-button>
			</b-nav-item>
		</b-navbar-nav>
	</b-navbar>
</template>

<script lang="ts">
    import {Component, Watch} from 'vue-property-decorator';
    import {ConnectionUtils, IconsUtils, LinkUtils, ScreenUtils} from "@/components/commons/Utils";
    import { mixins } from 'vue-class-component';
    import {Getter} from "vuex-class";
    import Download from '@/types/Download';
    import DownloadStateEnum from '@/enums/DownloadStateEnum';
    
	@Component({
		components: { }
	})
	export default class Header extends mixins(LinkUtils, ScreenUtils, IconsUtils, ConnectionUtils) {

        /** Pour pouvoir utiliser ces variables dans la section template */
        private downloadStateEnum = DownloadStateEnum;

        /** Récupère la liste des Téléchargement */
        @Getter('DownloadingStore/GetDownloadList')
        private downloadList!: Download[];

        /** Récupère la liste des Téléchargement */
        @Getter('DownloadingStore/GetAnimationState')
        private animation!: boolean;

        @Watch('animation', { immediate: true })
        private async openDropDown() {
            if (this.animation && this.downloadList[this.downloadList.length - 1].Direct === false) {
                (this.$refs.dlDrop as HTMLFormElement).visible = true;
            }
        }

        private generateDownload(download: Download) {
            if (download.State != DownloadStateEnum.Error) {
                download.State = DownloadStateEnum.Downloaded;
                this.GenerateFile(download.Data, download.Name);
            } else {
                this.$bvToast.toast(this.$t('CorruptedFile').toString(), { // "Le fichier est corrompu. Veuillez contacter votre administrateur."
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
        }
		
	}
</script>

<style scoped>

</style>